var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { compose, height, margin, width } from 'styled-system';
import { theme } from '../../essentials/theme';
import { extractClassNameProps, extractHeightProps, extractWidthProps, extractWrapperMarginProps } from '../../utils/extractProps';
import { useGeneratedId } from '../../utils/hooks/useGeneratedId';
import { BoxedInput } from '../Input/BoxedInput';
import { BoxedInputLabel } from '../Input/BoxedInputLabel';
const TextAreaWrapper = styled.div.attrs({ theme }).withConfig({ displayName: "TextAreaWrapper", componentId: "sc-1q5uxu8" }) `
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    width: 21.5rem;
    height: 7.25rem;

    ${compose(margin, height, width)}
`;
const TextareaField = styled(BoxedInput).attrs({
    as: 'textarea'
}).withConfig({ displayName: "TextareaField", componentId: "sc-l03izl" }) `
    height: 100%;
    padding: 0.75rem;
    overflow: auto;

    resize: ${p => p.resize};
`;
const Textarea = (_a) => {
    var { resize = 'both' } = _a, props = __rest(_a, ["resize"]);
    const { classNameProps, restProps: withoutClassName } = extractClassNameProps(props);
    const { marginProps, restProps: withoutMargin } = extractWrapperMarginProps(withoutClassName);
    const { widthProps, restProps: withoutWidth } = extractWidthProps(withoutMargin);
    const { heightProps, restProps } = extractHeightProps(withoutWidth);
    const { label, onChange } = restProps, rest = __rest(restProps, ["label", "onChange"]);
    const id = useGeneratedId(props.id);
    const [hasValue, setHasValue] = useState(rest.value && rest.value.toString().length > 0);
    const handleChange = event => {
        if (onChange) {
            onChange(event);
        }
    };
    useEffect(() => {
        setHasValue(rest.value && rest.value.toString().length > 0);
    }, [rest.value]);
    return (React.createElement(TextAreaWrapper, Object.assign({}, classNameProps, marginProps, widthProps, heightProps),
        React.createElement(TextareaField, Object.assign({}, rest, { resize: resize, id: id, variant: "boxed", size: "medium", hasValue: hasValue, onChange: handleChange })),
        label && (React.createElement(BoxedInputLabel, { htmlFor: id, waveSize: "medium" }, label))));
};
export { Textarea };
